import React from "react";
import { CustomInput } from "reactstrap";
import styles from "./style.module.scss";

export const CheckBox = props => {
  return (
    <CustomInput className={styles.RMcheckbox} {...props} type="checkbox" />
  );
};
